/* eslint-disable no-template-curly-in-string */
import Pagination from './vc-pagination/locale/phi';
import DatePicker from './date-picker/locale/phi';
import TimePicker from './time-picker/locale/phi';
import Calendar from './calendar/locale/phi';
var typeTemplate = '${label}不是一个有效的${type}';
var localeValues = {
  locale: 'phi',
  Pagination: Pagination,
  DatePicker: DatePicker,
  TimePicker: TimePicker,
  Calendar: Calendar,
  // locales for all components
  global: {
    placeholder: 'mangyaring pumili'
  },
  Table: {
    filterTitle: 'salain',
    filterConfirm: 'Oo naman',
    filterReset: 'i-reset',
    filterEmptyText: 'walang filter',
    filterCheckall: 'Piliin lahat',
    filterSearchPlaceholder: 'Maghanap sa mga filter',
    selectAll: 'Piliin ang lahat ng kasalukuyang pahina',
    selectInvert: 'Baligtarin ang kasalukuyang pahina',
    selectNone: 'Alisin lahat',
    selectionAll: 'Piliin lahat',
    sortTitle: 'upang ayusin',
    expand: 'Palawakin ang hilera',
    collapse: 'Isara ang hilera',
    triggerDesc: 'I-click para pababain ang order',
    triggerAsc: 'I-click upang umorder ng pataas',
    cancelSort: 'I-unsort'
  },
  Modal: {
    okText: 'Oo naman',
    cancelText: 'Kanselahin',
    justOkText: 'alam'
  },
  Popconfirm: {
    cancelText: 'Kanselahin',
    okText: 'Oo naman'
  },
  Transfer: {
    searchPlaceholder: 'Ipasok ang nilalaman ng paghahanap',
    itemUnit: 'aytem',
    itemsUnit: 'aytem',
    remove: 'tanggalin',
    selectCurrent: 'Piliin ang lahat ng kasalukuyang pahina',
    removeCurrent: 'Tanggalin ang kasalukuyang pahina',
    selectAll: 'Piliin lahat',
    removeAll: 'Tanggalin ang lahat',
    selectInvert: 'Baligtarin ang kasalukuyang pahina'
  },
  Upload: {
    uploading: 'Pag-upload ng file',
    removeFile: 'Tanggalin ang mga File',
    uploadError: 'error sa pag-upload',
    previewFile: 'preview na file',
    downloadFile: 'I-download ang file'
  },
  Empty: {
    description: 'Walang data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'i-edit',
    copy: 'kopya',
    copied: 'matagumpay na kopyahin',
    expand: 'Palawakin'
  },
  PageHeader: {
    back: 'bumalik'
  },
  Form: {
    optional: '(opsyonal)',
    defaultValidateMessages: {
      default: 'error sa pagpapatunay ng field${label}',
      required: 'pasok${label}',
      enum: '${label}dapat isa sa[${enum}]',
      whitespace: '${label}Hindi maaaring maging null character',
      date: {
        format: '${label}di-wastong format ng petsa',
        parse: '${label}hindi maaaring i-convert sa isang petsa',
        invalid: '${label}ay isang di-wastong petsa'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label}Dapat ay ${len} character',
        min: '${label}Minimum na ${min} character',
        max: '${label}hanggang ${max} character',
        range: '${label}Dapat ay nasa pagitan ng ${min}-${max}X-Y na mga character'
      },
      number: {
        len: '${label}dapat katumbas ng ${len}',
        min: '${label}Ang pinakamababang halaga ay ${min}',
        max: '${label}Ang maximum na halaga ay ${max}',
        range: '${label}Dapat nasa pagitan ng ${min}-${max}'
      },
      array: {
        len: 'Dapat si ${len}${label}',
        min: 'Hindi bababa sa ${min}${label}',
        max: 'Hanggang ${max}${label}',
        range: '${label}Ang dami ay dapat nasa pagitan ng ${min}-${max}'
      },
      pattern: {
        mismatch: '${label}hindi tumutugma sa pattern${pattern}'
      }
    }
  },
  Image: {
    preview: 'Silipin'
  }
};
export default localeValues;